<template>
  <SiteSearch placement="header" />
</template>

<script setup>
import SiteSearch from '~/components/search/SiteSearch.vue'
</script>
